import product1 from '../../images/product1.jpg'
import product2 from '../../images/product2.jpg'
import product3 from '../../images/product3.jpg'
import sweet1 from '../../images/sweet1.jpg'
import sweet2 from '../../images/sweet2.jpg'
import sweet3 from '../../images/sweet3.jpg'

export const productData = [
    {
        img: product1,
        alt: 'Cake',
        name: 'Chocolate Cake',
        desc: 'Chocolate flavour oozes all through this cake even though it’s  made with cocoa powder, like our very own Fudgy Chocolate Cake.',
        price: '$12.99',
        button: 'Add to Cart'
    },
    {
        img: product2,
        alt: 'Cake',
        name: 'Red Velvet',
        desc: 'This cake is buttery, soft and truly lives up to it’s velvet description. This cake also pairs really well with Ermine frosting. ',
        price: '$11.99',
        button: 'Add to Cart'
    },
    {
        img: product3,
        alt: 'Cake',
        name: 'Fruity Cake',
        desc: 'Classic fruit cake made with soaked unsweetened dried fruit. A festive, flavorful, and moist fruit cake to enjoy all holiday season',
        price: '$10.99',
        button: 'Add to Cart'
    }
]

export const productDataTwo = [
    {
        img: sweet1,
        alt: 'Cake',
        name: 'Nutty Cakes',
        desc: 'Three-layered Nutella Chocolate Cake with Swiss frosting is a show-stopping dessert, perfectly nutty, moist, and decadent.',
        price: '$12.99',
        button: 'Add to Cart'
    },
    {
        img: sweet2,
        alt: 'Cake',
        name: 'Super-Oreo cake',
        desc: 'This Oreo cake is beyond decadent. Filled with chopped Oreos, which add both creaminess and crunch and the buttercream . ',
        price: '$11.99',
        button: 'Add to Cart'
    },
    {
        img: sweet3,
        alt: 'Cake',
        name: 'Strawberry Cake',
        desc: 'Strawberyy cake made with soaked unsweetened dried fruit. A festive, flavorful, and moist fruit cake to enjoy all holiday season',
        price: '$10.99',
        button: 'Add to Cart'
    }
]